import { useEffect, useState } from "react";
import { useFlowManager } from "../../contexts/flowManager";
import CustomForm from '../CustomForm';
import { Link } from 'react-router-dom';
import serviceMethods from "../../service";
import { DateTime } from "luxon";
import BreadcrumbWrapper from "../BreadcrumbWrapper"

const ApplicationReview = () => {
  const [subscriptionTiers, setSubscriptionTiers] = useState([])
  const { selectedResponse, setSelectedResponse, setFormData, customFormId, setCustomFormId, selectedSubscription, selectedPurchase, setSelectedFlowStageId } = useFlowManager();
  const { getSubscriptionTiers } = serviceMethods;

  const clearFormData = () => {
    setFormData({})
    setSelectedResponse({})
    setCustomFormId('')
    setSelectedFlowStageId('')
  }

  const getTiers = async () => {
    const tiersRes = await getSubscriptionTiers()
    const tiers = await tiersRes.json()
    setSubscriptionTiers(tiers)
  }

  useEffect(() => {
    getTiers()
  }, [])

  return (
    <div>
      <BreadcrumbWrapper crumbArray={[{ path: '/flow-manager', label: 'Flow Manager' }, { path: '/review', label: 'Stage' }]} />
      <div className='w-full flex flex-col justify-center p-8 gap-4'>


        <button className='flex w-fit border px-2 py-1' onClick={() => { clearFormData() }}>
          <Link to="/flow-manager">Back to Flow Manager</Link>
        </button>

        <div>
          {/* response payload */}
          {selectedResponse?.payload?.map((row, i) => {
            return (
              <div key={`payload-${i}`} className='flex flex-col py-2 border-b'>
                <div className='flex gap-4'>
                  <h1>{i + 1}.</h1>
                  <p>{row.question}</p>
                </div>
                <div className='flex gap-4'>
                  <h1>Answer:</h1>
                  <p>{row.response}</p>
                </div>
              </div>
            )
          })}

          {Object.keys(selectedSubscription).length > 0 && (
            <div className='flex flex'>
              <div className='flex flex-col w-1/2'>
                <p>Tier: {subscriptionTiers?.find((tier) => tier.id === selectedSubscription.subscriptionTierId)?.title || 'n/a'}</p>
                <p>Price: {selectedSubscription.price || 'n/a'}</p>
                <p>Duration: {selectedSubscription.duration || 'n/a'}</p>
                <p>Subscription Unit: {selectedSubscription.subscriptionUnit || 'n/a'}</p>
                <p>Registration Code used: {selectedSubscription.registrationCodeId || 'n/a'}</p>
                <p>Confirmation Number: {selectedPurchase.confirmationNumber || 'n/a'}</p>

              </div>
              <div className='flex flex-col w-1/2'>

                <p>Begins at: {selectedSubscription.beginsAt ? DateTime.fromISO(selectedSubscription.beginsAt).toLocal().toFormat('yyyy-LL-dd') : 'n/a'}</p>
                <p>Renewal Attempts: {selectedSubscription.renewalAttempts}</p>
                <p>Renewed at: {selectedSubscription.renewedAt ? DateTime.fromISO(selectedSubscription.renewedAt).toLocal().toFormat('yyyy-LL-dd') : 'n/a'}</p>
                <p>Cancelled at: {selectedSubscription.cancelledAt ? DateTime.fromISO(selectedSubscription.cancelledAt).toLocal().toFormat('yyyy-LL-dd') : 'n/a'}</p>

              </div>


            </div>
          )}
        </div>

        {customFormId && <CustomForm />}

        <button className='flex w-fit border px-2 py-1' onClick={() => { clearFormData() }}>
          <Link to="/flow-manager">Back to Flow Manager</Link>
        </button>

      </div>
    </div>
  )
}

export default ApplicationReview;
